module.exports = __webpack_public_path__ + "img/soundninja.e145d6c7.jpg";